import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { PreventExitPopinAction, PreventExitPopinComponent } from '../../shared/components/prevent-exit-popin/prevent-exit-popin.component';
import { environment } from '@env/environment';

export interface CanDeactivateGuarded {
  canExit(): Observable<boolean>;
  save(): void;
  shareSendBackData(): void;
}

@Injectable({
  providedIn: 'root',
})
export class LeaveShareRecoService {
  constructor(private matDialog: MatDialog) {}

  canDeactivate(component: CanDeactivateGuarded): Observable<boolean> {
    return component.canExit().pipe(switchMap((canExit) => (canExit ? component.canExit() : this.preventExitDialog(component))));
  }

  private preventExitDialog(component: CanDeactivateGuarded): Observable<boolean> {
    return this.matDialog
      .open(PreventExitPopinComponent, {
        data: {
          isShowSendBackDataButton: environment.isShowSendBackDataButton,
        },
      })
      .afterClosed()
      .pipe(
        map((result) => {
          switch (result) {
            case PreventExitPopinAction.CANCEL:
              return false;

            case PreventExitPopinAction.NO_SAVE:
              return true;

            case PreventExitPopinAction.SAVE:
              component.save();
              return false;

            case PreventExitPopinAction.PMS_SEND_BACK_DATA:
              component.shareSendBackData();
              return false;

            default:
              return false;
          }
        }),
      );
  }
}
